import { render, staticRenderFns } from "./HostMemoryUsageTop.vue?vue&type=template&id=4c8f34b4"
import script from "./HostMemoryUsageTop.vue?vue&type=script&lang=js"
export * from "./HostMemoryUsageTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports